// Landningssidor för de kommuner Vector Security Group arbetar i.
// Varje kommun har egen text, egna områden och egna typiska uppdrag — både för
// att sidan ska vara användbar för besökaren och för att innehållet ska vara
// unikt för sökmotorerna.

export const areas = [
  {
    id: 'botkyrka',
    name: 'Botkyrka',
    districts: ['Tumba', 'Fittja', 'Alby', 'Hallunda', 'Norsborg', 'Vårsta', 'Grödinge'],
    focus: 'Bostadsrättsföreningar, industri och villor',
    metaTitle: 'Säkerhetsinstallation i Botkyrka | Vector Security Group',
    metaDescription:
      'Vi installerar passersystem, kamerabevakning, larm, lås och dörrautomatik i Botkyrka. Auktoriserad säkerhetsleverantör i Stockholms län. Boka kostnadsfri rådgivning.',
    lead:
      'Vector Security Group installerar passersystem, kamerabevakning, larm, lås och dörrautomatik i Botkyrka — från Tumba och Fittja till Vårsta och Grödinge.',
    paragraphs: [
      'I Botkyrka möter vi en blandad fastighetsbild: stora bostadsrättsföreningar och hyresfastigheter i Alby, Hallunda och Fittja, verksamhetslokaler och lager kring Tumba industriområde, samt villor i Vårsta och Grödinge. Vi projekterar och installerar säkerhetslösningar som passar varje fastighetstyp — från en enskild kortläsare i porten till kompletta system med kamerabevakning, porttelefoni och larm.',
      'För föreningar i Botkyrka handlar mycket om trygghet i entréer, garage och källargångar. Vi börjar alltid med en genomgång på plats, föreslår åtgärder i rätt ordning och lämnar fast pris. Våra installatörer arbetar i hela kommunen och har kort resväg från Nacka via Södra länken och E4.',
    ],
    typical: [
      'Porttelefoni och passersystem i BRF-entréer',
      'Kamerabevakning i garage, soprum och på lastkajer',
      'Inbrottslarm och lås i villa och verksamhet',
    ],
    nearby: ['huddinge', 'salem', 'stockholm'],
  },
  {
    id: 'danderyd',
    name: 'Danderyd',
    districts: ['Djursholm', 'Danderyds centrum', 'Enebyberg', 'Stocksund', 'Svalnäs'],
    focus: 'Villor, bostadsrättsföreningar och kontor',
    metaTitle: 'Säkerhetsinstallation i Danderyd | Vector Security Group',
    metaDescription:
      'Inbrottsskydd, kamerabevakning, lås och passersystem i Danderyd. Vi installerar säkerhetslösningar för villor, föreningar och kontor i Djursholm, Enebyberg och Stocksund.',
    lead:
      'Auktoriserad säkerhetsleverantör för villor, bostadsrättsföreningar och kontor i Danderyd — Djursholm, Enebyberg, Stocksund och Danderyds centrum.',
    paragraphs: [
      'Danderyd domineras av villor och äldre, välhållna bostadsfastigheter. Här handlar säkerhet ofta om inbrottsskydd, belysning, kamerabevakning och lås med kopieringsskyddade nycklar, snarare än stora systemutbyggnader. Vi gör en genomgång av fastigheten, visar var enkla åtgärder ger mest effekt och installerar därefter — alltid med ett diskret utförande som passar miljön.',
      'Vi hjälper också föreningar och kontor i Stocksund, Enebyberg och Danderyds centrum med porttelefoni, passersystem, dörrautomatik och larm. Eftersom många fastigheter i Danderyd är äldre lägger vi extra vikt vid att installationer görs utan att byggnadsdelar skadas, och att allt dokumenteras för förvaltningen.',
    ],
    typical: [
      'Inbrottsskydd och kamerabevakning i villa',
      'Lås och cylindrar med kopieringsskydd',
      'Porttelefoni och passersystem i förening',
    ],
    nearby: ['solna', 'taby', 'lidingo'],
  },
  {
    id: 'ekero',
    name: 'Ekerö',
    districts: ['Ekerö', 'Stenhamra', 'Skå', 'Färingsö', 'Munsö', 'Lovön'],
    focus: 'Villor, fritidshus och lantliga fastigheter',
    metaTitle: 'Säkerhetsinstallation i Ekerö | Vector Security Group',
    metaDescription:
      'Larm, kamerabevakning, lås och dörrautomatik i Ekerö. Vi installerar trådlösa säkerhetssystem för villor, fritidshus och verksamheter i hela kommunen.',
    lead:
      'Vi installerar larm, kamerabevakning, lås och dörrautomatik i Ekerö — från Stenhamra och Skå till Färingsö och Munsö.',
    paragraphs: [
      'Ekerö består till stora delar av villa- och fritidshusområden med långa avstånd och många fastigheter som står tomma delar av året. Där är inbrottslarm med appstyrning, utomhuskameror med nattseende och belysningsstyrning ofta de mest kostnadseffektiva åtgärderna. Vi installerar trådlösa system som inte kräver ingrepp i äldre byggnader, eller trådbundna lösningar när fastigheten är nyare.',
      'För verksamheter och lantliga fastigheter på Färingsö och Munsö hjälper vi till med passersystem, kamerabevakning över gårdar och uppfarter samt larm som är anpassade efter rörelse i miljön. Vi åker ut till hela Ekerö och lämnar alltid ett skriftligt förslag innan arbetet påbörjas.',
    ],
    typical: [
      'Trådlöst inbrottslarm för villa och fritidshus',
      'Utomhuskameror med nattseende',
      'Larm och kameror för lantliga fastigheter',
    ],
    nearby: ['stockholm', 'upplands-bro', 'jarfalla'],
  },
  {
    id: 'haninge',
    name: 'Haninge',
    districts: ['Handen', 'Jordbro', 'Västerhaninge', 'Tungelsta', 'Brandbergen', 'Dalarö'],
    focus: 'Bostäder, logistik och fritidshus',
    metaTitle: 'Säkerhetsinstallation i Haninge | Vector Security Group',
    metaDescription:
      'Passersystem, kamerabevakning, larm och lås i Haninge. Vi installerar säkerhetslösningar i Handen, Jordbro, Västerhaninge och skärgården. Boka kostnadsfri rådgivning.',
    lead:
      'Passersystem, kamerabevakning, larm och lås för fastigheter i Haninge — Handen, Jordbro, Västerhaninge, Tungelsta och Dalarö.',
    paragraphs: [
      'Haninge sträcker sig från Handens och Brandbergens bostadsområden till industri- och logistikfastigheter i Jordbro och vidare ut mot skärgården och Dalarö. Vi installerar porttelefoni och passersystem i flerbostadshus, kamerabevakning på lastkajer och uppställningsplatser, samt larm och lås i villa och fritidshus.',
      'Logistik- och industrifastigheter i Jordbro har ofta behov av kamerabevakning med tydliga zoner, passersystem för personal och grindstyrning. Vi projekterar systemen så att de går att bygga ut i etapper och dokumenterar allt för försäkringsbolag och egenkontroll. Installationerna utförs av våra egna montörer och följer gällande regelverk för kamerabevakning.',
    ],
    typical: [
      'Kamerabevakning och grindstyrning i logistik',
      'Porttelefoni i BRF och hyresfastighet',
      'Larm och lås i villa och fritidshus',
    ],
    nearby: ['nynashamn', 'tyreso', 'stockholm'],
  },
  {
    id: 'huddinge',
    name: 'Huddinge',
    districts: ['Huddinge centrum', 'Flemingsberg', 'Skogås', 'Trångsund', 'Segeltorp', 'Sjödalen'],
    focus: 'Bostäder, verksamheter och villor',
    metaTitle: 'Säkerhetsinstallation i Huddinge | Vector Security Group',
    metaDescription:
      'Passersystem, kamerabevakning, larm, lås och dörrautomatik i Huddinge. Vi installerar säkerhetslösningar i Flemingsberg, Skogås, Trångsund och Segeltorp.',
    lead:
      'Säkerhetsinstallation i Huddinge — passersystem, kamerabevakning, larm, lås och dörrautomatik i Flemingsberg, Skogås, Trångsund, Segeltorp och Sjödalen.',
    paragraphs: [
      'Huddinge har en stor andel flerbostadshus, men också campus- och vårdmiljöer i Flemingsberg, handelsområden i Kungens kurva och villor i Segeltorp och Sjödalen. Vi anpassar lösningen efter miljön: passersystem med spårbarhet i publika lokaler, porttelefoni och bokningstavlor i bostadsfastigheter, och diskret inbrottsskydd i villa.',
      'För fastighetsägare och föreningar i Huddinge hjälper vi också till med uppgradering av äldre låssystem, brandskyddsdörrar och dörrautomatik som förbättrar tillgängligheten i entréer. Vi börjar med ett kostnadsfritt platsbesök och lämnar en tydlig åtgärdsplan med priser.',
    ],
    typical: [
      'Passersystem med spårbarhet i verksamhet',
      'Uppgradering av äldre låssystem',
      'Dörrautomatik för bättre tillgänglighet',
    ],
    nearby: ['stockholm', 'botkyrka', 'tyreso'],
  },
  {
    id: 'jarfalla',
    name: 'Järfälla',
    districts: ['Jakobsberg', 'Kallhäll', 'Barkarby', 'Viksjö', 'Stäket', 'Barkarbystaden'],
    focus: 'Nyproduktion, bostäder och kontor',
    metaTitle: 'Säkerhetsinstallation i Järfälla | Vector Security Group',
    metaDescription:
      'Passersystem, kamerabevakning, larm och dörrautomatik i Järfälla. Vi installerar säkerhetslösningar i Jakobsberg, Kallhäll, Viksjö och Barkarbystaden.',
    lead:
      'Vector Security Group installerar passersystem, kamerabevakning, larm och dörrautomatik i Järfälla — Jakobsberg, Kallhäll, Viksjö, Stäket och Barkarbystaden.',
    paragraphs: [
      'Järfälla växer snabbt, framför allt i Barkarbystaden och Stäket där nyproducerade bostadsrättsföreningar och kontor tillkommer. I nyproduktion handlar mycket om att få porttelefoni, passersystem och kamerabevakning att samverka från början — och att systemen går att förvalta över tid. Vi tar fram lösningar som passar både den nya fastigheten och förvaltarens arbetssätt.',
      'I äldre bestånd i Jakobsberg, Kallhäll och Viksjö hjälper vi föreningar att byta ut slitna porttelefoner, komplettera med kortläsare och sätta upp kamerabevakning i garage och källargångar. Vi arbetar i hela Järfälla och lämnar alltid fast pris samt dokumentation över utförd installation.',
    ],
    typical: [
      'Porttelefoni och passersystem i nyproduktion',
      'Byte av äldre porttelefonsystem',
      'Kamerabevakning i garage och källargångar',
    ],
    nearby: ['stockholm', 'solna', 'upplands-bro'],
  },
  {
    id: 'lidingo',
    name: 'Lidingö',
    districts: ['Lidingö centrum', 'Brevik', 'Sticklinge', 'Skärsätra', 'Rudboda', 'Käppala'],
    focus: 'Villor, föreningar och verksamheter',
    metaTitle: 'Säkerhetsinstallation i Lidingö | Vector Security Group',
    metaDescription:
      'Lås, larm, kamerabevakning, passersystem och dörrautomatik på Lidingö. Vi installerar säkerhetslösningar för villor, föreningar och verksamheter.',
    lead:
      'Auktoriserad säkerhetsleverantör på Lidingö — lås, larm, kamerabevakning, passersystem och dörrautomatik för villor, föreningar och verksamheter.',
    paragraphs: [
      'Lidingö består till stor del av villor och äldre bostadsfastigheter i områden som Brevik, Sticklinge, Skärsätra och Rudboda. Här är efterfrågan oftast inbrottsskydd, säkra lås och kamerabevakning snarare än stora system. Vi tittar på helheten — dörrar, fönster, belysning och uppfarter — och föreslår åtgärder i rätt ordning så att du får mest skydd för pengarna.',
      'Föreningar och verksamheter på Lidingö hjälper vi med porttelefoni, passersystem, bokningstavlor och dörrautomatik. Många fastigheter är från mitten av 1900-talet, vilket ställer krav på varsam installation och genomtänkta kabeldragningar. Vi dokumenterar varje installation och lämnar underlag för förvaltning och försäkring.',
    ],
    typical: [
      'Inbrottsskydd och säkra lås i villa',
      'Kamerabevakning och belysningsstyrning',
      'Dörrautomatik och passersystem i förening',
    ],
    nearby: ['stockholm', 'danderyd', 'taby'],
  },
  {
    id: 'nacka',
    name: 'Nacka',
    districts: ['Nacka Strand', 'Sickla', 'Orminge', 'Boo', 'Älta', 'Saltsjöbaden'],
    focus: 'Kontor, bostäder och villor',
    metaTitle: 'Säkerhetsinstallation i Nacka | Vector Security Group',
    metaDescription:
      'Passersystem, kamerabevakning, larm, lås och dörrautomatik i Nacka. Vi har basen i Nacka och installerar säkerhetslösningar i Sickla, Orminge, Boo och Saltsjöbaden.',
    lead:
      'Med bas i Nacka installerar vi passersystem, kamerabevakning, larm, lås och dörrautomatik i Nacka Strand, Sickla, Orminge, Boo, Älta och Saltsjöbaden.',
    paragraphs: [
      'Nacka är vår hemkommun och här har vi vår största lokala närvaro. Vi arbetar med kontors- och handelsfastigheter i Sickla och Nacka Strand, stora bostadsrättsföreningar i Orminge och Boo, samt villor i Saltsjöbaden och Älta. Det ger oss korta inställelsetider och god kännedom om både fastighetsbestånd och förvaltare i kommunen.',
      'För verksamheter i Nacka Strand och Sickla handlar projekten ofta om kombinationen passersystem, kamerabevakning och larm kopplade till en gemensam administration. I bostadsfastigheter är porttelefoni, bokningstavlor och garagebevakning mest efterfrågat. Vi projekterar, installerar och sköter service — från en enstaka kortläsare till helhetslösningar.',
    ],
    typical: [
      'Helhetslösning för kontor och handel',
      'Porttelefoni och bokningstavlor i BRF',
      'Villalarm och kamerabevakning',
    ],
    nearby: ['stockholm', 'varmdo', 'tyreso'],
  },
  {
    id: 'norrtalje',
    name: 'Norrtälje',
    districts: ['Norrtälje', 'Rimbo', 'Hallstavik', 'Älmsta', 'Bergshamra', 'Skärgården'],
    focus: 'Fritidshus, verksamheter och villor',
    metaTitle: 'Säkerhetsinstallation i Norrtälje | Vector Security Group',
    metaDescription:
      'Larm, kamerabevakning, lås och passersystem i Norrtälje. Vi installerar säkerhetslösningar för fritidshus, villor och verksamheter i hela kommunen.',
    lead:
      'Vi installerar larm, kamerabevakning, lås och passersystem i Norrtälje — Norrtälje stad, Rimbo, Hallstavik, Älmsta och skärgården.',
    paragraphs: [
      'Norrtälje är till ytan en av länets största kommuner, med allt från tätorten och industri i Hallstavik till fritidshus längs kusten och i skärgården. För fritidshus och säsongsboende rekommenderar vi nästan alltid larm med appstyrning och kamerabevakning — åtgärder som gör störst skillnad när ingen är på plats. Systemen installeras trådlöst och kräver minimalt ingrepp i byggnaden.',
      'I Norrtälje stad, Rimbo och Hallstavik hjälper vi fastighetsägare och företag med passersystem, porttelefoni, dörrautomatik och larm. Vi tar hänsyn till att avstånden är långa genom att planera arbetet i tydliga steg och samla servicebesöken, så att restid och kostnad hålls nere.',
    ],
    typical: [
      'Larm med appstyrning för fritidshus',
      'Kamerabevakning av fastighet på distans',
      'Passersystem och dörrautomatik i verksamhet',
    ],
    nearby: ['ostersaker', 'vallentuna', 'vaxholm'],
  },
  {
    id: 'nykvarn',
    name: 'Nykvarn',
    districts: ['Nykvarn', 'Turinge', 'Björkesta', 'Finkarby'],
    focus: 'Villor, föreningar och företag',
    metaTitle: 'Säkerhetsinstallation i Nykvarn | Vector Security Group',
    metaDescription:
      'Larm, kamerabevakning, lås, passersystem och dörrautomatik i Nykvarn. Vi installerar säkerhetslösningar för villor, föreningar och företag.',
    lead:
      'Säkerhetsinstallation i Nykvarn — larm, kamerabevakning, lås, passersystem och dörrautomatik för villor, föreningar och företag.',
    paragraphs: [
      'Nykvarn är en mindre kommun där många pendlar till Södertälje och Stockholm, och där en stor del av beståndet är villor och mindre flerbostadshus. Det gör att helhetslösningar ofta är enklare och mer överskådliga: larm, utomhuskameror, säkra lås och belysning som styrs tillsammans. Vi går igenom fastigheten på plats och föreslår bara de åtgärder som verkligen gör nytta.',
      'För verksamheter kring E20 och i Turingeområdet installerar vi passersystem, kamerabevakning över upplag och entréer samt larm som anpassas efter verksamhetens tider. Vi lämnar fast pris, utför arbetet med egna montörer och lämnar dokumentation som fungerar vid försäkringsärenden.',
    ],
    typical: [
      'Larm och kamerabevakning för villa',
      'Passersystem i mindre företag',
      'Kamerabevakning över upplag och entréer',
    ],
    nearby: ['sodertalje', 'salem', 'stockholm'],
  },
  {
    id: 'nynashamn',
    name: 'Nynäshamn',
    districts: ['Nynäshamn', 'Ösmo', 'Sorunda', 'Torö', 'Landsort', 'Skärgården'],
    focus: 'Hamn, logistik, bostäder och fritidshus',
    metaTitle: 'Säkerhetsinstallation i Nynäshamn | Vector Security Group',
    metaDescription:
      'Passersystem, kamerabevakning, larm och lås i Nynäshamn. Vi installerar säkerhetslösningar i tätorten, Ösmo, Sorunda och skärgården.',
    lead:
      'Vi installerar passersystem, kamerabevakning, larm och lås i Nynäshamn — tätorten, Ösmo, Sorunda och skärgården.',
    paragraphs: [
      'Nynäshamn är en hamn- och pendlarkommun med industri- och logistikverksamhet kring hamnen, villaområden i Ösmo och Sorunda samt många fritidshus i skärgården. För hamn- och logistikfastigheter är kamerabevakning med tydliga zoner, passersystem och grindstyrning de vanligaste behoven. I villa och fritidshus är larm och utomhuskameror mest efterfrågat.',
      'Vi hjälper också bostadsrättsföreningar i Nynäshamns tätort med porttelefoni, kortläsare och garagebevakning, samt verksamheter med larm och dörrautomatik. Alla installationer följer gällande regelverk, inklusive krav på skyltning och hantering av inspelat material vid kamerabevakning.',
    ],
    typical: [
      'Kamerabevakning och grindstyrning i hamn och logistik',
      'Larm i fritidshus och villa',
      'Porttelefoni i bostadsrättsförening',
    ],
    nearby: ['haninge', 'sodertalje', 'stockholm'],
  },
  {
    id: 'salem',
    name: 'Salem',
    districts: ['Salem', 'Rönninge', 'Viksängen', 'Söderby'],
    focus: 'Villor, radhus och föreningar',
    metaTitle: 'Säkerhetsinstallation i Salem | Vector Security Group',
    metaDescription:
      'Larm, kamerabevakning, lås, porttelefoni och passersystem i Salem. Vi installerar säkerhetslösningar för villor, radhus och bostadsrättsföreningar.',
    lead:
      'Säkerhetsinstallation i Salem — larm, kamerabevakning, lås, porttelefoni och passersystem för villor och föreningar.',
    paragraphs: [
      'Salem är en liten kommun med en blandning av villor, radhus och mindre flerbostadshus i Salem, Rönninge och kring Viksängen. Det är nära till Södertälje och Botkyrka, och de flesta uppdrag är koncentrerade och snabba att genomföra. Vi hjälper både privatpersoner och föreningar med allt från säkra lås och inbrottslarm till porttelefoni och kamerabevakning i garage.',
      'För föreningar i Salem handlar det ofta om att uppgradera en porttelefoni som tjänat ut, komplettera med kortläsare vid soprum och cykelrum samt sätta upp kamerabevakning där skadegörelse förekommit. Vi gör en kostnadsfri genomgång, prioriterar åtgärderna och lämnar fast pris på hela paketet.',
    ],
    typical: [
      'Uppgradering av porttelefoni i förening',
      'Inbrottslarm och säkra lås i villa',
      'Kamerabevakning i garage och soprum',
    ],
    nearby: ['sodertalje', 'botkyrka', 'nykvarn'],
  },
  {
    id: 'sigtuna',
    name: 'Sigtuna',
    districts: ['Märsta', 'Valsta', 'Rosersberg', 'Sigtuna', 'Arlanda-området'],
    focus: 'Verksamheter, logistik och bostäder',
    metaTitle: 'Säkerhetsinstallation i Sigtuna | Vector Security Group',
    metaDescription:
      'Passersystem, kamerabevakning, larm och dörrautomatik i Sigtuna. Vi installerar säkerhetslösningar i Märsta, Valsta, Rosersberg och Sigtuna stad.',
    lead:
      'Passersystem, kamerabevakning, larm och dörrautomatik i Sigtuna — Märsta, Valsta, Rosersberg, Sigtuna stad och Arlanda-området.',
    paragraphs: [
      'Sigtuna kombinerar flyg- och logistikverksamhet kring Arlanda och Rosersberg med bostadsområden i Märsta och Valsta samt den historiska stadskärnan i Sigtuna. För verksamheter nära Arlanda handlar projekten ofta om passersystem med hög säkerhet, kamerabevakning av områden och larm kopplade till larmcentral. I bostadsfastigheter är porttelefoni, bokningstavlor och garagebevakning vanligast.',
      'I Sigtuna stad är fastigheterna äldre och ofta kulturhistoriskt värdefulla, vilket ställer krav på varsamma installationer och diskreta utföranden. Vi anpassar lösningen efter byggnaden, dokumenterar allt och lämnar underlag som fungerar i kontakter med försäkringsbolag och myndigheter.',
    ],
    typical: [
      'Passersystem och larm för verksamhet nära Arlanda',
      'Kamerabevakning av upplag och lastzoner',
      'Varsam installation i äldre fastighet',
    ],
    nearby: ['upplands-vasby', 'upplands-bro', 'vallentuna'],
  },
  {
    id: 'sollentuna',
    name: 'Sollentuna',
    districts: ['Sollentuna centrum', 'Tureberg', 'Häggvik', 'Edsberg', 'Rotebro'],
    focus: 'Kontor, bostäder och villor',
    metaTitle: 'Säkerhetsinstallation i Sollentuna | Vector Security Group',
    metaDescription:
      'Passersystem, kamerabevakning, larm, lås och dörrautomatik i Sollentuna. Vi installerar säkerhetslösningar i Tureberg, Häggvik, Edsberg och Rotebro.',
    lead:
      'Vi installerar passersystem, kamerabevakning, larm, lås och dörrautomatik i Sollentuna — Tureberg, Häggvik, Edsberg, Rotebro och Sollentuna centrum.',
    paragraphs: [
      'Sollentuna har en tydlig blandning av kontorsfastigheter i Häggvik och kring Sollentuna centrum, stora bostadsområden i Edsberg och Tureberg samt villaområden i Rotebro och norrut. Vi anpassar lösningen efter verksamheten: passersystem med behörighetsstyrning och kamerabevakning i kontor, porttelefoni och garagebevakning i bostadsfastigheter, inbrottsskydd i villa.',
      'Många fastighetsägare i Sollentuna efterfrågar lösningar som går att administrera centralt och bygga ut i takt med att verksamheten växer. Vi projekterar därför system med öppna gränssnitt, dokumenterar installationen och erbjuder service så att systemet fungerar över tid.',
    ],
    typical: [
      'Passersystem och kamerabevakning i kontor',
      'Porttelefoni och garagebevakning i BRF',
      'Inbrottsskydd i villa',
    ],
    nearby: ['stockholm', 'solna', 'taby'],
  },
  {
    id: 'solna',
    name: 'Solna',
    districts: ['Solna centrum', 'Arenastaden', 'Hagalund', 'Huvudsta', 'Råsunda', 'Frösunda'],
    focus: 'Kontor, nyproduktion och bostäder',
    metaTitle: 'Säkerhetsinstallation i Solna | Vector Security Group',
    metaDescription:
      'Säkerhetsinstallation i Solna — passersystem, kamerabevakning, larm, lås och dörrautomatik för kontor, föreningar och bostäder i Arenastaden, Råsunda och Huvudsta.',
    lead:
      'Säkerhetsinstallation i Solna — Arenastaden, Hagalund, Huvudsta, Råsunda, Frösunda och Solna centrum.',
    paragraphs: [
      'Solna är en av landets mest expansiva kommuner med kontors- och evenemangsområden i Arenastaden och Frösunda, äldre bostadsbestånd i Råsunda och Huvudsta samt nyproduktion i flera stadsdelar. Det ger en bredd av uppdrag: från passersystem och kamerabevakning i kontorsfastigheter till porttelefoni, bokningstavlor och garagebevakning i bostadsrättsföreningar.',
      'För verksamheter i Solna är kombinationen passersystem, kamerabevakning och larm med gemensam administration ofta det mest effektiva. För föreningar handlar det mer om trygga entréer, soprum och garage samt att få ordning på behörigheter och nyckelhantering. Vi gör alltid en genomgång på plats och lämnar ett skriftligt förslag med fast pris.',
    ],
    typical: [
      'Passersystem och kamerabevakning i kontor',
      'Porttelefoni och bokningstavlor i BRF',
      'Trygghet i entré, soprum och garage',
    ],
    nearby: ['stockholm', 'sundbyberg', 'danderyd'],
  },
  {
    id: 'stockholm',
    name: 'Stockholm',
    districts: ['Södermalm', 'Östermalm', 'Kungsholmen', 'Vasastan', 'Bromma', 'Farsta', 'Hässelby'],
    focus: 'Innerstad, ytterstad, kontor och butik',
    metaTitle: 'Säkerhetsinstallation i Stockholm | Vector Security Group',
    metaDescription:
      'Passersystem, kamerabevakning, larm, lås och dörrautomatik i Stockholm. Vi installerar säkerhetslösningar i innerstaden såväl som i ytterstaden.',
    lead:
      'Vector Security Group installerar passersystem, kamerabevakning, larm, lås och dörrautomatik i hela Stockholm — innerstaden såväl som ytterstaden.',
    paragraphs: [
      'I Stockholm arbetar vi i allt från sekelskiftesfastigheter på Södermalm, Östermalm och Kungsholmen till nyproducerade bostadsrättsföreningar i Bromma, Farsta, Skarpnäck och Hässelby. I innerstaden handlar mycket om porttelefoni, passersystem och uppgradering av äldre låssystem i fastigheter där ingreppen måste vara varsamma. I ytterstaden är kamerabevakning, garageportar och dörrautomatik i entréer vanliga uppdrag.',
      'För kontor, butik och verksamhet i city projekterar vi kombinationer av passersystem, kamerabevakning och larm som ger spårbarhet och kontroll över flera entréer och plan. Vi tar hänsyn till gällande regelverk för kamerabevakning, hanterar dokumentation och erbjuder serviceavtal så att systemen fungerar år efter år.',
    ],
    typical: [
      'Porttelefoni och passersystem i innerstadsfastighet',
      'Kamerabevakning i butik och kontor',
      'Dörrautomatik och garageportar i ytterstaden',
    ],
    nearby: ['solna', 'nacka', 'sundbyberg'],
  },
  {
    id: 'sundbyberg',
    name: 'Sundbyberg',
    districts: ['Centrala Sundbyberg', 'Hallonbergen', 'Rissne', 'Duvbo', 'Stora Ursvik'],
    focus: 'Nyproduktion, bostäder och kontor',
    metaTitle: 'Säkerhetsinstallation i Sundbyberg | Vector Security Group',
    metaDescription:
      'Passersystem, kamerabevakning, larm och lås i Sundbyberg. Vi installerar säkerhetslösningar i Centrala Sundbyberg, Hallonbergen, Rissne och Stora Ursvik.',
    lead:
      'Passersystem, kamerabevakning, larm och lås i Sundbyberg — Centrala Sundbyberg, Hallonbergen, Rissne, Duvbo och Stora Ursvik.',
    paragraphs: [
      'Sundbyberg är en av landets mest tätbefolkade kommuner och växer vidare i Stora Ursvik och kring stationen. Här finns många nyproducerade bostadsrättsföreningar där porttelefoni, passersystem och kamerabevakning i garage och cykelrum är centralt, parallellt med äldre bestånd i Hallonbergen och Rissne där systemen ofta behöver uppgraderas.',
      'För föreningar i Sundbyberg är nyckelhantering och behörigheter en återkommande fråga. Vi hjälper till att gå från mekaniska nycklar till kortläsare eller tagg, kopplar på porttelefoni och bokningstavlor och ser till att administrationen blir enkel för styrelsen. Allt dokumenteras så att kunskapen stannar i föreningen.',
    ],
    typical: [
      'Kortläsare och porttelefoni i nyproduktion',
      'Byte från nyckel till behörighetssystem',
      'Kamerabevakning i garage och cykelrum',
    ],
    nearby: ['stockholm', 'solna', 'jarfalla'],
  },
  {
    id: 'sodertalje',
    name: 'Södertälje',
    districts: ['Södertälje', 'Ronna', 'Hovsjö', 'Pershagen', 'Järna', 'Enhörna'],
    focus: 'Industri, bostäder och landsbygd',
    metaTitle: 'Säkerhetsinstallation i Södertälje | Vector Security Group',
    metaDescription:
      'Passersystem, kamerabevakning, larm och dörrautomatik i Södertälje. Vi installerar säkerhetslösningar i tätorten, Ronna, Hovsjö, Järna och Enhörna.',
    lead:
      'Vi installerar passersystem, kamerabevakning, larm och dörrautomatik i Södertälje — tätorten, Ronna, Hovsjö, Pershagen, Järna och Enhörna.',
    paragraphs: [
      'Södertälje har en stark industritradition med stora verksamheter, hamn och logistik, kombinerat med bostadsområden i Ronna, Hovsjö och Pershagen samt villa- och landsbygdsfastigheter i Järna och Enhörna. För industrin handlar projekten ofta om passersystem med zoner och spårbarhet, kamerabevakning över stora ytor och larm kopplade till egen eller extern larmcentral.',
      'I bostadsfastigheter hjälper vi föreningar och förvaltare med porttelefoni, kortläsare, bokningstavlor och kamerabevakning i garage och utemiljö. Vi arbetar i hela kommunen och planerar installationerna så att de stör verksamheten så lite som möjligt — ofta i etapper och med tydliga tidplaner.',
    ],
    typical: [
      'Passersystem med zoner i industri',
      'Kamerabevakning över stora ytor',
      'Porttelefoni och bokningstavlor i BRF',
    ],
    nearby: ['salem', 'nykvarn', 'botkyrka'],
  },
  {
    id: 'tyreso',
    name: 'Tyresö',
    districts: ['Tyresö centrum', 'Bollmora', 'Trollbäcken', 'Krusboda', 'Brevik'],
    focus: 'Villor, föreningar och trygghet',
    metaTitle: 'Säkerhetsinstallation i Tyresö | Vector Security Group',
    metaDescription:
      'Säkerhetsinstallation i Tyresö — larm, kamerabevakning, lås, porttelefoni och passersystem för villor och bostadsrättsföreningar.',
    lead:
      'Säkerhetsinstallation i Tyresö — Tyresö centrum, Bollmora, Trollbäcken, Krusboda och Brevik.',
    paragraphs: [
      'Tyresö består av villaområden i Trollbäcken och Brevik, flerbostadshus i Bollmora och Krusboda samt ett växande centrumområde. Vi installerar inbrottslarm, kamerabevakning och säkra lås i villa, och porttelefoni, passersystem och garagebevakning i föreningar. Många uppdrag börjar med att vi gör en trygghetsgenomgång av fastigheten tillsammans med styrelsen.',
      'Eftersom Tyresö till stora delar består av bostadsområden är efterfrågan på trygghet i entréer, garage och utemiljö stor. Vi arbetar med kamerabevakning som är korrekt skyltad och hanterad enligt regelverket, och med belysning och passersystem som minskar skadegörelse. Allt lämnas med dokumentation och fast pris.',
    ],
    typical: [
      'Trygghetsgenomgång tillsammans med styrelsen',
      'Kamerabevakning i garage och utemiljö',
      'Larm och lås i villa',
    ],
    nearby: ['stockholm', 'nacka', 'haninge'],
  },
  {
    id: 'taby',
    name: 'Täby',
    districts: ['Täby centrum', 'Näsbypark', 'Arninge', 'Gribbylund', 'Viggbyholm', 'Hägernäs'],
    focus: 'Villor, kontor och handel',
    metaTitle: 'Säkerhetsinstallation i Täby | Vector Security Group',
    metaDescription:
      'Passersystem, kamerabevakning, larm och dörrautomatik i Täby. Vi installerar säkerhetslösningar i Näsbypark, Arninge, Gribbylund och Täby centrum.',
    lead:
      'Passersystem, kamerabevakning, larm och dörrautomatik i Täby — Täby centrum, Näsbypark, Arninge, Gribbylund, Viggbyholm och Hägernäs.',
    paragraphs: [
      'Täby kombinerar stora villaområden i Näsbypark, Gribbylund och Viggbyholm med kontors- och handelsverksamhet i Arninge och kring Täby centrum. I villorna är inbrottsskydd, kamerabevakning och säkra lås mest efterfrågat, medan verksamheterna ofta behöver passersystem, larm och kamerabevakning över entréer, lager och lastzoner.',
      'Föreningar i Täby hjälper vi med porttelefoni, bokningstavlor, garageportar och dörrautomatik. Vi ser till att installationen görs med hänsyn till fastighetens utformning, att behörigheter blir lätta att administrera och att allt dokumenteras för framtida förvaltning och service.',
    ],
    typical: [
      'Inbrottsskydd och kamerabevakning i villa',
      'Passersystem och larm i verksamhet',
      'Garageportar och dörrautomatik i förening',
    ],
    nearby: ['danderyd', 'sollentuna', 'ostersaker'],
  },
  {
    id: 'upplands-bro',
    name: 'Upplands-Bro',
    districts: ['Kungsängen', 'Bro', 'Brunna', 'Håbo-Tibble'],
    focus: 'Nyproduktion, villor och verksamheter',
    metaTitle: 'Säkerhetsinstallation i Upplands-Bro | Vector Security Group',
    metaDescription:
      'Säkerhetsinstallation i Upplands-Bro — porttelefoni, passersystem, larm och kamerabevakning för bostäder, villor och verksamheter.',
    lead:
      'Säkerhetsinstallation i Upplands-Bro — Kungsängen, Bro, Brunna och Håbo-Tibble.',
    paragraphs: [
      'Upplands-Bro växer kring Kungsängen och Bro, med nyproducerade bostadsområden nära pendeltåget och villor i äldre delar av kommunen. I nyproduktion handlar det ofta om porttelefoni, passersystem och kamerabevakning i garage och cykelrum. I villaområden är inbrottslarm, utomhuskameror och säkra lås de vanligaste åtgärderna.',
      'Verksamheter i Brunna och längs E18 hjälper vi med kamerabevakning, passersystem och larm anpassade efter verksamhetens tider och flöden. Vi lämnar alltid ett skriftligt förslag med fast pris, utför arbetet med egna montörer och lämnar dokumentation över installationen.',
    ],
    typical: [
      'Porttelefoni och passersystem i nyproduktion',
      'Inbrottslarm och kameror i villa',
      'Kamerabevakning i verksamhet längs E18',
    ],
    nearby: ['jarfalla', 'upplands-vasby', 'sigtuna'],
  },
  {
    id: 'upplands-vasby',
    name: 'Upplands Väsby',
    districts: ['Väsby centrum', 'Smedby', 'Bollstanäs', 'Vilunda', 'Fresta'],
    focus: 'Industri, logistik och bostäder',
    metaTitle: 'Säkerhetsinstallation i Upplands Väsby | Vector Security Group',
    metaDescription:
      'Passersystem, kamerabevakning, larm och lås i Upplands Väsby. Vi installerar säkerhetslösningar för industri, logistik och bostadsfastigheter.',
    lead:
      'Vi installerar passersystem, kamerabevakning, larm och lås i Upplands Väsby — Väsby centrum, Smedby, Bollstanäs, Vilunda och Fresta.',
    paragraphs: [
      'Upplands Väsby har ett stort inslag av industri- och logistikfastigheter kring Vilunda och längs E4, kombinerat med bostadsområden i Smedby, Bollstanäs och Fresta samt ett växande centrum. För industri och logistik är kamerabevakning med zoner, passersystem och grindstyrning de vanligaste behoven. I bostadsfastigheter är porttelefoni, bokningstavlor och garagebevakning mest efterfrågat.',
      'Vi projekterar systemen så att de går att bygga ut i etapper och kan administreras centralt, vilket passar verksamheter med flera byggnader eller förvaltare med flera objekt. Installationerna följer gällande regelverk och dokumenteras för egenkontroll och försäkring.',
    ],
    typical: [
      'Kamerabevakning och grindstyrning i logistik',
      'Passersystem för flera byggnader',
      'Porttelefoni i bostadsfastighet',
    ],
    nearby: ['sigtuna', 'upplands-bro', 'sollentuna'],
  },
  {
    id: 'vallentuna',
    name: 'Vallentuna',
    districts: ['Vallentuna', 'Kårsta', 'Lindholmen', 'Brottby', 'Össeby-Garn'],
    focus: 'Villor, landsbygd och föreningar',
    metaTitle: 'Säkerhetsinstallation i Vallentuna | Vector Security Group',
    metaDescription:
      'Säkerhetsinstallation i Vallentuna — trådlösa larm, kamerabevakning, lås och passersystem för villor, lantliga fastigheter och föreningar.',
    lead:
      'Säkerhetsinstallation i Vallentuna — Vallentuna tätort, Kårsta, Lindholmen, Brottby och Össeby-Garn.',
    paragraphs: [
      'Vallentuna är en kommun med mycket villa- och landsbygdsfastigheter, där avstånden mellan fastigheterna kan vara långa. Det gör trådlösa larmsystem, utomhuskameror och lösningar som kan styras på distans särskilt lämpliga. Vi installerar också säkra lås, belysningsstyrning och dörrautomatik där det behövs.',
      'För föreningar i Vallentuna tätort och verksamheter i Brottby och Lindholmen hjälper vi med porttelefoni, passersystem och kamerabevakning. Eftersom kommunen är vidsträckt planerar vi servicebesöken noggrant, så att du får snabb hjälp utan onödiga kostnader för restid.',
    ],
    typical: [
      'Trådlöst larm och kameror för villafastighet',
      'Fjärrstyrd säkerhet för lantlig fastighet',
      'Porttelefoni och passersystem i förening',
    ],
    nearby: ['taby', 'ostersaker', 'sigtuna'],
  },
  {
    id: 'vaxholm',
    name: 'Vaxholm',
    districts: ['Vaxholm', 'Resarö', 'Kullö', 'Rindö', 'Skarpö'],
    focus: 'Skärgårdsfastigheter och verksamheter',
    metaTitle: 'Säkerhetsinstallation i Vaxholm | Vector Security Group',
    metaDescription:
      'Säkerhetsinstallation i Vaxholm — trådlösa larm, kamerabevakning, lås och passersystem för skärgårdsfastigheter och verksamheter.',
    lead:
      'Säkerhetsinstallation i Vaxholm — Vaxholm stad, Resarö, Kullö, Rindö och Skarpö.',
    paragraphs: [
      'Vaxholm är en skärgårdskommun med många äldre och kulturhistoriskt värdefulla fastigheter, fritidshus och villor på öarna. Här ställer installationer krav på hänsyn till byggnaderna, och lösningarna behöver ofta vara trådlösa och diskreta. Larm med appstyrning, utomhuskameror och säkra lås är de mest efterfrågade åtgärderna.',
      'För verksamheter i Vaxholm stad och bostadsfastigheter på Resarö och Rindö hjälper vi med passersystem, porttelefoni, dörrautomatik och kamerabevakning. Vi tar hänsyn till transporter och tillgänglighet i skärgårdsmiljö och planerar arbetet så att allt material finns på plats vid installationstillfället.',
    ],
    typical: [
      'Trådlöst larm i äldre skärgårdsfastighet',
      'Kamerabevakning av villa och fritidshus',
      'Passersystem och porttelefoni i verksamhet',
    ],
    nearby: ['ostersaker', 'varmdo', 'taby'],
  },
  {
    id: 'varmdo',
    name: 'Värmdö',
    districts: ['Gustavsberg', 'Hemmesta', 'Mölnvik', 'Ingarö', 'Djurö', 'Stavsnäs'],
    focus: 'Fritidshus, villor och bostäder',
    metaTitle: 'Säkerhetsinstallation i Värmdö | Vector Security Group',
    metaDescription:
      'Passersystem, kamerabevakning, larm och dörrautomatik i Värmdö. Vi installerar säkerhetslösningar i Gustavsberg, Hemmesta, Ingarö och skärgården.',
    lead:
      'Med bas i Nacka installerar vi passersystem, kamerabevakning, larm och dörrautomatik i Värmdö — Gustavsberg, Hemmesta, Mölnvik, Ingarö, Djurö och Stavsnäs.',
    paragraphs: [
      'Värmdö har en lång kustlinje med fritidshus och villor från Ingarö och Gustavsberg ut mot Djurö och Stavsnäs, kombinerat med tätorten Gustavsberg och handelsområdet i Mölnvik. Vi installerar larm med appstyrning och utomhuskameror i fritidshus och villa, samt porttelefoni, passersystem och kamerabevakning i bostadsfastigheter och verksamheter.',
      'Vi har kort resväg till Värmdö från vår bas i Nacka, vilket ger snabba inställelsetider och möjlighet till service utan långa restider. För föreningar i Gustavsberg och Hemmesta hjälper vi ofta till med att uppgradera porttelefoni och låssystem samt att sätta upp kamerabevakning i garage och soprum.',
    ],
    typical: [
      'Larm och kameror i fritidshus och villa',
      'Porttelefoni och passersystem i BRF',
      'Kamerabevakning i garage och soprum',
    ],
    nearby: ['nacka', 'vaxholm', 'tyreso'],
  },
  {
    id: 'ostersaker',
    name: 'Österåker',
    districts: ['Åkersberga', 'Svinninge', 'Täljö', 'Röllingby', 'Hacksta'],
    focus: 'Villor, fritidshus och föreningar',
    metaTitle: 'Säkerhetsinstallation i Österåker | Vector Security Group',
    metaDescription:
      'Säkerhetsinstallation i Österåker — larm, kamerabevakning, lås, porttelefoni och dörrautomatik för villor, fritidshus och föreningar.',
    lead:
      'Säkerhetsinstallation i Österåker — Åkersberga, Svinninge, Täljö, Röllingby och Hacksta.',
    paragraphs: [
      'Österåker består till stora delar av villa- och fritidshusområden längs skärgården, med tätorten Åkersberga som centrum. Inbrottslarm, kamerabevakning och säkra lås är de vanligaste åtgärderna i villa och fritidshus, ofta kombinerat med belysningsstyrning och larm som kan hanteras i mobilen när huset står tomt.',
      'I Åkersberga och Röllingby hjälper vi också föreningar och verksamheter med porttelefoni, passersystem, dörrautomatik och kamerabevakning. Vi gör en genomgång på plats, prioriterar åtgärderna efter effekt och kostnad och lämnar fast pris innan arbetet börjar.',
    ],
    typical: [
      'Larm och kameror i villa och fritidshus',
      'Belysningsstyrning för obebodd fastighet',
      'Porttelefoni och dörrautomatik i förening',
    ],
    nearby: ['vaxholm', 'taby', 'vallentuna'],
  },
];

export function getArea(id) {
  return areas.find((a) => a.id === id);
}